document.addEventListener('DOMContentLoaded', () => {
  const FADE_CLASS = 'godfather-stats-bar__value--fading';
  const FADE_DURATION = 300;
  const CYCLE_INTERVAL = 2000;

  const cycleEl = (el) => {
    const values = el.dataset.cycleValues
      .split(',')
      .map((v) => v.trim())
      .filter(Boolean);

    if (values.length < 2) return;

    let index = 0;

    setInterval(() => {
      index = (index + 1) % values.length;
      el.classList.add(FADE_CLASS);

      setTimeout(() => {
        el.textContent = values[index];
        el.classList.remove(FADE_CLASS);
      }, FADE_DURATION);
    }, CYCLE_INTERVAL);
  };

  document.querySelectorAll('[data-cycle-values]').forEach(cycleEl);
});
